import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useDispatch } from "react-redux";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { close_snack_bar } from "../../Common/snackbar/action";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Dashboard = ({ login, client, onLogout, snackbar, viewOldCarLength, viewTestDriveLength, viewContactUsLengths }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [contactData, setContactData] = useState({
    labels: [],
    datasets: [{ label: "Contacts", data: [], backgroundColor: "#74b9ff" }],
  });

  const [testDriveData, setTestDriveData] = useState({
    labels: [],
    datasets: [{ label: "Test Drive", data: [], backgroundColor: "#55efc4" }],
  });

  const fetchData = () => {
    viewOldCarLength(login.token, login.user_id);
    viewTestDriveLength(login.token, login.user_id);
    viewContactUsLengths(login.token, login.user_id);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (client.viewContactUsLength) {
      const { labels, counts } = client.viewContactUsLength;
      setContactData({
        labels,
        datasets: [{ label: "Contacts", data: counts, backgroundColor: "#a29bfe" }],
      });
    }
    if (client.viewTestdriveLength) {

      const { labels, counts } = client.viewTestdriveLength;
      setTestDriveData({
        labels,
        datasets: [{ label: "Test Drive", data: counts, backgroundColor: "#81ecec" }],
      });
    }
  }, [client.viewContactUsLength, client?.viewTestdriveLength]);

  return (
    <div className="dashboard-container">

      <div className="content">
        <h1 className="title">Dashboard Overview</h1>

        {/* Cards */}
        <div className="cards-row">
          <div className="card card-blue">
            <h2>Old Cars</h2>
            <p>{client?.oldcarlength || 0}</p>
          </div>

          <div className="card card-purple">
            <h2>Test Drives</h2>
            <p>{client?.viewTestdriveLength?.totalLength || 0}</p>
          </div>

          <div className="card card-orange">
            <h2>Contacts</h2>
            <p>{client?.viewContactUsLength?.totalLength || 0}</p>
          </div>
        </div>

        {/* Charts */}
        <div className="charts-row">
          <div className="chart-card">
            <h3>Book Test Drive</h3>
            <Bar data={testDriveData} />
          </div>

          <div className="chart-card">
            <h3>Contact</h3>
            <Bar data={contactData} />
          </div>
        </div>
      </div>

      {/* UI Styling */}
      <style>{`
        .dashboard-container {
          display: flex;
          background: #f4f7fb;
          min-height: 100vh;
          font-family: 'Inter', sans-serif;
        }

        .title {
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 20px;
          color: #2d3436;
        }

        .content {
          padding: 40px 30px;
          width: 100%;
        }

        /* Cards */
        .cards-row {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
          margin-bottom: 30px;
        }

        .card {
          flex: 1;
          padding: 25px;
          border-radius: 16px;
          color: #fff;
          font-weight: 600;
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
          transition: 0.3s;
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.15);
        }

        .card h2 {
          margin-bottom: 10px;
          font-size: 20px;
        }

        .card p {
          font-size: 26px;
          font-weight: bold;
        }

        .card-blue {
          background: #74b9ff;
        }

        .card-purple {
          background: #a29bfe;
        }

        .card-orange {
          background: #fab1a0;
        }

        /* Charts */
        .charts-row {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }

        .chart-card {
          flex: 1;
          padding: 25px;
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 20px rgba(0,0,0,0.08);
        }

        .chart-card h3 {
          margin-bottom: 15px;
          color: #2d3436;
          font-size: 18px;
        }

        @media (max-width: 768px) {
          .content {
            padding: 20px;
          }
        }
      `}</style>
      <Snackbar1
        open={snackbar.response_received}
        close_snack_bar={() => dispatch(close_snack_bar())}
        message={snackbar.message}
      />
    </div>
  );
};

export default Dashboard;
